/**
 * Utility functions for supplier operations
 * Follows Single Responsibility Principle - handles supplier logic
 */

export const getSupplierName = (
  supplierData: any,
  ingredientId: string,
  supplierId: string
): string => {
  let supplierName = "";
  if (supplierData) {
    supplierData.forEach((supplier: any) => {
      if (
        supplier.isFetched &&
        supplier.data._id === supplierId &&
        supplier.data.ingredientIds.includes(ingredientId)
      ) {
        supplierName = supplier.data.supplier_name;
      }
    });
  }
  return supplierName;
};

export const extractSupplierIds = (ingredientList: any[]): string[] => {
  const ids: string[] = [];
  ingredientList.forEach((ingredient: any) => {
    const supplierId = ingredient?.data?.reference?.supplierId;
    if (supplierId) {
      ids.push(supplierId);
    }
  });
  return ids;
};
